export default __webpack_public_path__ + "static/monotype-helvetica-display-medium-7e33766ef5a1658d5cdd49e38ac5918a.woff";